import { render, staticRenderFns } from "./PaginaDestinatari.vue?vue&type=template&id=731545b8"
import script from "./PaginaDestinatari.vue?vue&type=script&lang=js"
export * from "./PaginaDestinatari.vue?vue&type=script&lang=js"
import style0 from "./PaginaDestinatari.vue?vue&type=style&index=0&id=731545b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports